"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2022 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitterFactory = void 0;
const BrowserEventEmitter_1 = require("./BrowserEventEmitter");
const EventEmitter_1 = require("./EventEmitter");
const StorageEventEmitter_1 = require("./StorageEventEmitter");
class EventEmitterFactory {
    static getEmitter(key, isBroadcastAllowed) {
        const isBrowser = new Function("try {return this===window;}catch(e){ return false;}")();
        // To be checked first: BroadCastChannel supported (everything except Safari & IE)
        const isBroadCastChannelSupported = isBrowser && !!window.BroadcastChannel && isBroadcastAllowed;
        if (isBroadCastChannelSupported) {
            return new BrowserEventEmitter_1.BrowserEventEmitter(key);
        }
        // Second: LocalStorage event supported (nearly everything except if set off by user/browser setting)
        const isLocalStorageSupported = isBrowser && StorageEventEmitter_1.StorageEventEmitter.isSupported() && isBroadcastAllowed;
        if (isLocalStorageSupported) {
            return new StorageEventEmitter_1.StorageEventEmitter(key);
        }
        // Default, no cross tab messaging supported
        return new EventEmitter_1.EventEmitter();
    }
}
exports.EventEmitterFactory = EventEmitterFactory;
